import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { I18n } from 'react-redux-i18n';
import Select, { createFilter } from 'react-select';

import Dropdown, { components } from "@common/containers/fields/Dropdown";
import { getTestAttributes } from "@common/utils/tests";


import Tree, { getItem } from "../Tree";

import './TreeDropdown.styles.scss';

export default class TreeDropdown extends Component {
    static propTypes = {
        items: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                name: PropTypes.node.isRequired,
                children: PropTypes.array,
            })
        ),
        showFolderIcon: PropTypes.bool,
    };

    static defaultProps = {
        items: [],
        classes: {},
        placeholder: I18n.t('Select Folder'),
        showFolderIcon: false
    };

    dropdownRef = React.createRef();

    state = {
        isOpen: false,
        selectedItem: {},
        menuPlacement: 'auto',
    };

    onChange = (id, item) => {
        this.close();
        this.props.onChange(id, item);
    }

    computeMenuPlacement = () => {
        const dd = this.dropdownRef.current;
        const el = dd && dd.selectRef && dd.selectRef.current;
        if (!el || typeof window === 'undefined') return 'auto';
        const rect = el.getBoundingClientRect();
        const buffer = 16;
        const desired = 190;
        const spaceBelow = window.innerHeight - rect.bottom - buffer;
        const spaceAbove = rect.top - buffer;
        if (spaceBelow >= desired) return 'bottom';
        if (spaceAbove >= desired) return 'top';
        return spaceBelow >= spaceAbove ? 'bottom' : 'top';
    }

    open = () => {
        const menuPlacement = this.computeMenuPlacement();
        this.setState((state) => ({
            ...state,
            isOpen: true,
            menuPlacement,
        }));
    }

    close = () => {
        this.setState((state) => ({
            ...state,
            isOpen: false,
        }));
    }

    getMenuStyles = (css) => ({
        ...css,
        width: undefined,
    });

    getCustomControlComponent = (props) => {
        const { showFolderIcon } = this.props;
        const { children, ...controlProps } = props;

        if (!showFolderIcon) {
            return <components.Control {...controlProps}>{children}</components.Control>;
        }

        return (
            <components.Control {...controlProps}>
                <div className="TreeDropdown__control-with-icon">
                    <img 
                        src="gif/folder_closed.gif" 
                        alt="Folder" 
                        className="TreeDropdown__folder-icon"
                    />
                    {children}
                </div>
            </components.Control>
        );
    };

    getMenuListComponent = (props) => {

        const { items, className, value, collapseAfterLevel, classes } = this.props;
        
        return (
          <components.MenuList {...props} className={cx("TreeDropdown__menu", classes?.menu)}>
            <Tree
              collapseAfterLevel={collapseAfterLevel}
              className="TreeDropdown__menu__inner"
              items={items}
              value={value}
              onChange={this.onChange}
            />
          </components.MenuList>
        );
      };
      

    render() {
        const { items, placeholder, className, value, id, showFolderIcon, fullWidth, ...otherProps } = this.props;
        const { isOpen, menuPlacement } = this.state;
        const selectedItem = getItem(value, items);

        return (
          <Dropdown
            ref={this.dropdownRef}
            fullWidth={fullWidth}
            className={cx("TreeDropdown", className)}
            id={id}
            selectedValue={selectedItem?.name}
            searchable={false}
            placeholder={placeholder}
            menuIsOpen={isOpen}
            onMenuOpen={this.open}
            onBlur={this.close}
            menuPlacement={menuPlacement}
            styles={{
              menu: this.getMenuStyles,
            }}
            menuListComponent={items?.length ? this.getMenuListComponent : undefined}
            controlComponent={showFolderIcon ? this.getCustomControlComponent : undefined}
            {...otherProps}
          />
        );
    }
}
